module.exports = __webpack_public_path__ + "static/media/twitter.7f3b2877.png";


/*****************
 ** WEBPACK FOOTER
 ** ./src/views/pages/home/sections/twitterQuotes/components/twitterQuote/assets/twitter.png
 ** module id = 574
 ** module chunks = 0
 **/